import React, { useState } from 'react';
import CirclePanelHeader from '../coo-dashboard/components/CirclePanelHeader';
import CircleTabNav from '../coo-dashboard/components/CircleTabNav';
import CooHero from '../coo-dashboard/components/CooHero';
import CooTopBar from './components/PocTopBar';
import DomainLegend from '../coo-dashboard/components/DomainLegend';
import DomainSection from '../coo-dashboard/components/DomainSection';
import PageFooter from '../coo-dashboard/components/PageFooter';
import ZoneKpiSection from '../coo-dashboard/components/ZoneKpiSection';
import pocDashboardData from './data/pocDashboardData';
import BubbleShell from '../chatbot/components/BubbleShell';

export default function PocDashboardPage() {
  const [activeCircle, setActiveCircle] = useState(pocDashboardData.circles[0]?.id || 'HP');

  return (
    <div data-coo="page" className="min-h-screen bg-app-bg text-slate-700">
      <CooTopBar />

      <main className="mx-auto max-w-7xl space-y-6 px-4 py-6 sm:px-6 lg:px-8">
        <CooHero meta={pocDashboardData.meta} />
        <DomainLegend legend={pocDashboardData.legend} alert={pocDashboardData.alert} />

        {pocDashboardData.zoneSummarySections.map((section) => (
          <ZoneKpiSection key={section.title} section={section} />
        ))}

        <CircleTabNav circles={pocDashboardData.circles} activeCircle={activeCircle} onChange={setActiveCircle} />

        <div className="space-y-5">
          {pocDashboardData.circles.map((circle) => {
            const isActive = circle.id === activeCircle;
            return (
              <section
                key={circle.id}
                id={`circle-panel-${circle.id}`}
                data-coo="circle-panel"
                role="tabpanel"
                aria-labelledby={`circle-tab-${circle.id}`}
                hidden={!isActive}
                className={isActive ? 'block' : 'hidden'}
              >
                <CirclePanelHeader circle={circle} />
                <div className="mt-4 space-y-4">
                  {circle.sections.map((section) => (
                    <DomainSection key={section.id} section={section} />
                  ))}
                </div>
              </section>
            );
          })}
        </div>

        <PageFooter lines={pocDashboardData.footer} />
      </main>

      {/* Drishti bubble — floats bottom-right over the POC dashboard.
          Same backend + knowledge file as /chatbot. */}
      <BubbleShell enabled />
    </div>
  );
}
